<deprecated-labeled-field [label]="label">
  <div
    #dropdown
    class="rv-flex dropdown"
    [class.disabled]="disabled"
    [class.error]="error"
    [class.warning]="warning"
    [attr.tabindex]="disabled ? null : 0"
    [focusOnInit]="autoFocus"
  >
    <button-dropdown
      class="optionButton"
      #numberComparatorDropdown
      [icon]="'ChevronDown'"
      [iconPosition]="'last'"
    >
      <ng-container button-content>{{ selectedOption }}</ng-container>
      <div class="rv-card surface-0">
        <single-select
          [options]="options"
          (selectedOptionChange)="
            numberComparatorDropdown.close(); onOptionChange($event)
          "
        ></single-select>
      </div>
    </button-dropdown>
    <deprecated-text-field
      class="number-value"
      name="number-comparator-value"
      type="number"
      [placeholder]="'0'"
      [ngModel]="value"
      (ngModelChange)="onValueChange($event)"
    ></deprecated-text-field>
  </div>
</deprecated-labeled-field>
